import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  unallocatedPayments: [],
  loadingUnallocated: false,
  errorLoadingUnallocated: null,
  pagination: {},
};

export const unallocatedPaymentSlice = createSlice({
  name: "unallocatedPayment",
  initialState,
  reducers: {
    setLoadingUnallocated: (state) => {
      state.loadingUnallocated = true;
      state.errorLoadingUnallocated = null;
    },
    setUnallocatedPayments: (state, { payload }) => {
      state.loadingUnallocated = false;
      state.unallocatedPayments = payload;
    },
    setErrorLoadingUnallocated: (state, { payload }) => {
      state.loadingUnallocated = false;
      state.errorLoadingUnallocated = payload;
    },
    setUnallocatedPagination: (state, { payload }) => {
      state.pagination = payload;
    },
  },
});

export const {
  setLoadingUnallocated,
  setUnallocatedPayments,
  setErrorLoadingUnallocated,
  setUnallocatedPagination,
} = unallocatedPaymentSlice.actions;

export default unallocatedPaymentSlice.reducer;
